import React, { useEffect, useState } from 'react';
import { useAppContext } from '../../share-components/AppContext';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { ROUTE_SHOP_LIST } from '../../constants/routeConstants';
import { Button, Card } from 'react-bootstrap';
import { ErrorMessage, Field, Formik, Form } from 'formik';
import AlertDialog from '../../share-components/AlertDialog';
import { addShop } from '../../services/ShopService';
import FormTitle from '../../share-components/FormTitle';
import { SERVER_ERROR_MESSAGE } from '../../constants/commonConstants';

const AddShop = () => {
    const { setLoading, setRouteNaviData, setShowApiErrorMessage } = useAppContext();
    const [showSuccessDialog, setShowSuccessDialog] = useState(false);
    const navigate = useNavigate();

    const initialValues = {
        shopName: '',
    };

    useEffect(() => {
        setRouteNaviData("MANAGEMENT >> NEW SHOP")
    }, [])

    const validationSchema = Yup.object({
        shopName: Yup.string()
            .required('Shop Name is required.')
            .max(50, 'Shop Name must not exceed 50 characters.')
    });

    const onSubmit = async (form) => {
        setLoading(true);
        try {
            const response = await addShop(form);
            setShowSuccessDialog(true);
        } catch (error) {
            const errMsg = error?.response?.data?.errorMessage || SERVER_ERROR_MESSAGE;
            if (error.status !== 401 && error.status !== 403) {
                setShowApiErrorMessage(errMsg);
            }
        } finally {
            setLoading(false);
        }
    };

    const handleSuccessDialogClose = () => {
        setShowSuccessDialog(false);
        navigate(ROUTE_SHOP_LIST);
    }

    return (
        <>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', paddingBottom: '50px' }}>
                <Card style={{ width: '100%', maxWidth: '400px', padding: '20px', margin: '0 auto' }}>
                    <Card.Body>
                        <FormTitle title={"New Shop"} isCenter={true}/>
                        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
                            {({ errors, isValid, dirty }) => {
                                return (
                                    <Form>
                                        <div className="mb-3">
                                            <label className="form-label custom-label">Shop Name*</label>
                                            <Field name="shopName" type="text" className="form-control customInputControl" autoComplete="off" />
                                            <ErrorMessage name="shopName" component="div" className="text-danger" />
                                        </div>

                                        <Button
                                            className="w-100"
                                            type="submit"
                                            variant="primary"
                                            disabled={!(isValid && dirty)}
                                        >
                                            Save
                                        </Button>

                                        {/* <MessageTooltip
                  id='btnLoginDisabledMsg'
                  isDisabledObj={true}
                  tooltipText={firstError}>
                  <Button type="submit" variant="primary" disabled={!isValid || !dirty}>Login</Button>
                </MessageTooltip> */}
                                    </Form>
                                );
                            }}
                        </Formik>
                    </Card.Body>
                </Card>
            </div>
            <AlertDialog
                dialogId={'successDialog'}
                showDialog={showSuccessDialog}
                body={'New shop has been added.'}
                onConfirm={handleSuccessDialogClose}
            />
        </>
    );
};

export default AddShop;